import React from "react";
import axios from "axios";
import Conf from "./Conf";
import Navbar from "./components/Navbar";
import QRCode from "qrcode.react";
import { Grid } from "@material-ui/core";
import { goLogin, getPermission } from "./js/main";
import PaymentIcon from "@material-ui/icons/Payment";
import BillPreview from "./components/BillPreview";

const current_path = Conf.frontendURL + "report";
const page_title = "Payment";
var io_connected = false;

export default class Tranfer extends React.Component {
  state = {
    invoice: {},
    cookie: null,
    paid: false,
  };

  componentDidMount() {
    this.getAuth();
  }
  async getAuth() {
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if (cookie && cookie.token) {
      var auth = await getPermission(cookie.token);
      var invoice = await this.getInvoice();
      var paid = false;
      if (invoice.canceled.status === true || invoice.bills.length > 0)
        paid = true;
      if (auth === false) goLogin(current_path);
      else
        this.setState(
          {
            profile: auth.profile,
            cookie: cookie,
            invoice: invoice,
            paid: paid,
          },
          async () => {
            if (paid !== true) this.openSocket();
            else {
              var i = invoice.bills.length - 1;
              var otp = await this.getOTP(invoice.bills[i]);
              this.setState({ otp });
            }
          }
        );
    } else goLogin(current_path);
  }
  getOTP(bill_id) {
    console.log("GET OTP");
    return new Promise(async (resolve) => {
      // var bill_id = this.props.match.params.id;
      var bill = await this.getBill(bill_id);
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      axios
        .post(
          Conf.digitalpayBackend + "otp",
          { type: "bill_preview", payload: { bill_id: bill.bill_id } },
          {
            headers: { Authorization: cookie.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        });
    });
  }
  openSocket() {
    var socket = require("socket.io-client")(Conf.digitalpayBackend);
    if (io_connected === false) {
      io_connected = true;
      socket.on("connect", function () {
        console.log("Connect ");
      });
    }
    var that = this;
    var { invoice } = this.state;
    socket.on("payment-" + invoice._id, async function (data) {
      var bill = JSON.parse(data);
      var inv = await that.getInvoice();
      if (inv._id === bill.invoice_id) {
        that.setState({ paid: true }, async () => {
          var i = inv.bills.length - 1;
          console.log(bill);
          console.log(inv);
          var otp = await that.getOTP(inv.bills[i]);
          console.log(otp);
          that.setState({ otp });
        });
      }
    });
    socket.on("disconnect", function () {});
  }
  getInvoice() {
    return new Promise((resolve) => {
      var id = this.props.match.params.id;
      axios.get(Conf.backendURL + "invoice/" + id).then((res) => {
        resolve(res.data);
      });
    });
  }
  showFieldValue(id) {
    var { invoice } = this.state;
    if (invoice[id] && invoice[id] !== "") return invoice[id];
    else return "-";
  }
  getBill(id) {
    return new Promise((resolve) => {
      axios
        .get(Conf.digitalpayBackend + "bill/" + id, {
          headers: { Authorization: this.state.cookie.token },
        })
        .then((res) => {
          resolve(res.data);
        });
    });
  }
  render() {
    const { invoice, paid, otp } = this.state;
    const styles = {
      fieldName: {
        fontWeight: 500,
        fontSize: "0.8rem",
      },
      fieldValue: {
        fontSize: "1.5rem",
        paddingBottom: "20px",
      },
    };
    return (
      <>
        {invoice.invoice_id && (
          <div>
            <Navbar />
            <main className="content">
              <h1 className="pageTitle">
                <div
                  style={{
                    float: "left",
                    padding: "5px",
                    marginRight: "15px",
                  }}
                >
                  <PaymentIcon style={{ fontSize: "2rem" }} />
                </div>
                <div style={{ float: "none" }}>{page_title}</div>
              </h1>
              <br />
              {paid === false ? (
                <>
                  <Grid container>
                    <Grid item xs={12} md={6} style={{ paddingLeft: "30px" }}>
                      <div style={styles.fieldName}>
                        ชื่อผู้ชำระเงิน (Payer Name)
                      </div>
                      <div style={styles.fieldValue}>{invoice.debtor_name}</div>
                      <div style={styles.fieldName}>
                        หมายเลขบัตรประชาชน/หมายเลขผู้เสียภาษี (ID Card/Tax
                        Number)
                      </div>
                      <div style={styles.fieldValue}>
                        {this.showFieldValue("debtor_idx")}
                      </div>
                      {/* <div style={styles.fieldName}>
                        หมายเลขผู้เสียภาษี (VAT Number)
                      </div>
                      <div style={styles.fieldValue}>
                        {this.showFieldValue("debtor_vat")}
                      </div> */}
                      <div style={styles.fieldName}>
                        อีเมลสำหรับจัดส่งใบเสร็จ (e-Mail)
                      </div>
                      <div style={styles.fieldValue}>
                        {this.showFieldValue("debtor_email")}
                      </div>
                      <div style={styles.fieldName}>ที่อยู่ (Address)</div>
                      <div style={{ fontSize: "1.2rem" }}>
                        {this.showFieldValue("debtor_address")}
                      </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <div
                        style={{
                          border: "2px solid #111",
                          textAlign: "center",
                          width: "253px",
                          margin: "auto",
                        }}
                      >
                        {invoice.code && (
                          <>
                            <div>
                              <img
                                src={`${process.env.PUBLIC_URL}/img/thai_qr_payment.png`}
                                style={{ width: "250px" }}
                                alt=""
                              />
                            </div>
                            <div>
                              <img
                                src={`${process.env.PUBLIC_URL}/img/card.png`}
                                style={{ width: "249px" }}
                                alt=""
                              />
                            </div>
                            <div>
                              <QRCode
                                value={invoice.code}
                                renderAs="svg"
                                size={200}
                                imageSettings={{
                                  src: `${process.env.PUBLIC_URL}/img/qrlogo.png`,
                                  height: 30,
                                  width: 30,
                                }}
                              />
                            </div>

                            <div style={{ height: "70px", paddingTop: "5px" }}>
                              <div
                                style={{
                                  textAlign: "left",
                                  paddingLeft: "10px",
                                  fontSize: ".9em",
                                  float: "left",
                                }}
                              >
                                สำนักหอสมุด
                                <br />
                                มหาวิทยาลัยเชียงใหม่
                                <div style={{ fontSize: ".8em" }}>
                                  099400042317916
                                </div>
                              </div>
                              <div
                                style={{
                                  textAlign: "center",
                                  width: "100px",
                                  float: "right",
                                  paddingTop: "10px",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "1.2em",
                                    lineHeight: "1em",
                                  }}
                                >
                                  {invoice.amount.toLocaleString()}
                                </div>
                                <div style={{ fontSize: ".8em" }}>บาท</div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <h1>สำนักหอสมุดได้รับเงินแล้ว</h1>
                  {invoice &&
                    invoice.debtor_email &&
                    invoice.debtor_email !== "" && (
                      <div style={{ fontSize: "1.2rem" }}>
                        ใบเสร็จรับเงินจะถูกส่งไปยังอีเมล
                        <br />
                        {invoice.debtor_email}
                      </div>
                    )}

                  {otp && <BillPreview otp={otp} />}
                </div>
              )}
            </main>
          </div>
        )}
      </>
    );
  }
}
